import { render } from "./ReceivingAgreements.vue?vue&type=template&id=00917de4&scoped=true"
import script from "./ReceivingAgreements.vue?vue&type=script&lang=js"
export * from "./ReceivingAgreements.vue?vue&type=script&lang=js"

import "./ReceivingAgreements.vue?vue&type=style&index=0&id=00917de4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00917de4"]])

export default __exports__